import axios from 'axios';
import { BaseService } from './BaseService';

export class PartnerService extends BaseService {

    async getPartners(offset = 0, skip = 0, limit = 10, sortField = 'id', sortOrder = 1, filters) {
        let newFilter = this.getFilters(filters);

        let parameters = {
            "offset": offset,
            "limit": limit,
            "skip": skip,
            "order": `${sortField} ${sortOrder == 1 ? 'asc' : 'desc'}`,
        };

        if (newFilter) {
            parameters["where"] = newFilter;
        }
        let res = await this.get(`/partners?filter=${encodeURI(JSON.stringify(parameters))}`, true);
        return {
            data: res,
            page: skip
        }
    }

    async getCountPartners(filters) {
        let newFilter = this.getFilters(filters);
        let parameters = null;
        let strWhere = ''

        if (newFilter) {
            parameters = JSON.stringify({...newFilter});
        }

        if (parameters) {
            strWhere += `?where=${encodeURI(parameters)}`;
        }
        return this.get(`/partners/count${strWhere}`, true).then(res => res.count);
    }

    getFilters(filters = {}) {
        let newFilter = null;

        const fromTo = {
            'contains': 'like',
            'equals': 'eq'
        };

        if (filters) {
            for (const [key, value] of Object.entries(filters)) {
                console.log(`${key}:`, value);
                if (value.constraints[0].value != null) {
                    let newValue = {};

                    let operator = fromTo[value.constraints[0].matchMode];

                    if (operator == 'like') {
                        newValue[operator] = `%${value.constraints[0].value}%`;
                    } else {
                        newValue[operator] = value.constraints[0].value;
                    }

                    if (newFilter == null) {
                        newFilter = {}
                    }

                    newFilter[key] = newValue;
                }
            }
        }
        return newFilter;
    }

    async getPartnerImage(id, type = 'image') {
        const data = await this.get(`/partners/${id}/image?type=${type}`, true);
        return data.image ?? null;
    }

    async deletePartner(id) {
        return await this.delete(`/partners/${id}`, true);
    }

    async editPartner(partner, imageFile = null, logoFile = null, originalImage = null, originalLogo = null) {
        const formData = new FormData();
        
        formData.append('name', partner.name || '');
        formData.append('title', partner.title || '');
        formData.append('subtitle', partner.subtitle || '');
        formData.append('link', partner.link || '');
        formData.append('color', partner.color || '');
        formData.append('active', partner.active ? 'true' : 'false');
        
        // Adiciona imagens apenas se houver arquivo novo
        if (imageFile) {
            formData.append('image', imageFile);
        }
        // Se não há arquivo novo mas havia imagem antes e agora está vazio, indica remoção
        else if (!imageFile && originalImage && (partner.image === '' || partner.image === null || partner.image === undefined)) {
            formData.append('removeImage', 'true');
        }
        
        if (logoFile) {
            formData.append('logo', logoFile);
        }
        // Se não há arquivo novo mas havia logo antes e agora está vazio, indica remoção
        else if (!logoFile && originalLogo && (partner.logo === '' || partner.logo === null || partner.logo === undefined)) {
            formData.append('removeLogo', 'true');
        }
        
        const config = this.getConfig(true);
        delete config.headers['Content-Type']; // Deixa o browser definir o boundary
        
        return await axios.patch(
            `${process.env.REACT_APP_API_URL}/partners/${partner.id}`, 
            formData, 
            config
        ).then(res => res.data);
    }

    async createPartner(partner, imageFile = null, logoFile = null) {
        const formData = new FormData();
        
        formData.append('name', partner.name);
        formData.append('title', partner.title || '');
        formData.append('subtitle', partner.subtitle || '');
        formData.append('link', partner.link || '');
        formData.append('color', partner.color || '');
        formData.append('active', partner.active ? 'true' : 'false');
        
        // Adiciona imagens apenas se houver arquivo
        if (imageFile) {
            formData.append('image', imageFile);
        }
        
        if (logoFile) {
            formData.append('logo', logoFile);
        }
        
        const config = this.getConfig(true);
        delete config.headers['Content-Type']; // Deixa o browser definir o boundary
        
        return await axios.post(
            `${process.env.REACT_APP_API_URL}/partners`, 
            formData, 
            config
        ).then(res => res.data);
    }
}

